<div class="time-picker-overlay" *ngIf="isOpen" (click)="onCancel()" (keydown.escape)="onCancel()">
  <div class="time-picker-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">>

    <!-- Header com horário selecionado -->
    <div class="time-picker-header">
      <div class="selected-time">
        <button type="button" class="time-part hour-part" [class.active]="showingHours" (click)="showingHours = true">
          {{ selectedHour.toString().padStart(2, '0') }}
        </button>
        <span class="separator">:</span>
        <button type="button" class="time-part minute-part" [class.active]="!showingHours" (click)="showingHours = false">
          {{ selectedMinute.toString().padStart(2, '0') }}
        </button>
        <span class="period">{{ getPeriod() }}</span>
      </div>
    </div>

    <!-- Área do relógio -->
    <div class="clock-container">
      <svg class="clock-face" width="300" height="300" viewBox="0 0 280 280">

        <!-- Círculo do relógio -->
        <circle cx="140" cy="140" r="135" fill="#f8f9fa" stroke="#e0e0e0" stroke-width="1"/>

        <!-- Ponteiro das horas (pequeno) -->
        <line
          [attr.x1]="centerX"
          [attr.y1]="centerY"
          [attr.x2]="getHourHandPosition().x"
          [attr.y2]="getHourHandPosition().y"
          class="hour-hand"
          stroke="#9C9FA5"
          stroke-width="4"
          stroke-linecap="round"/>

        <!-- Ponteiro dos minutos (grande) -->
        <line
          [attr.x1]="centerX"
          [attr.y1]="centerY"
          [attr.x2]="getMinuteHandPosition().x"
          [attr.y2]="getMinuteHandPosition().y"
          class="minute-hand"
          stroke="#9C9FA5"
          stroke-width="3"
          stroke-linecap="round"/>

        <!-- Centro do relógio -->
        <circle [attr.cx]="centerX" [attr.cy]="centerY" r="6" fill="#9C9FA5"/>

        <!-- Números das horas (sempre visível, mais afastado) -->
        <!-- Desenhado depois dos ponteiros para que os números/badges fiquem sempre por cima -->
        <g class="clock-numbers hours-outer">
          <!-- Círculo ativo atrás do número selecionado -->
          <circle
            [attr.cx]="getHourPosition(selectedHour).x + 14"
            [attr.cy]="getHourPosition(selectedHour).y + 14"
            r="18"
            fill="#408AFA"
            class="active-circle hour-active"/>

          <text
            *ngFor="let hour of hours"
            [attr.x]="getHourPosition(hour).x + 14"
            [attr.y]="getHourPosition(hour).y + 18"
            [class.active]="selectedHour === hour"
            (click)="selectHour(hour)"
            (keydown.enter)="selectHour(hour)"
            (keydown.space)="selectHour(hour)"
            tabindex="0"
            class="clock-number hour-number">
            {{ hour }}
          </text>
        </g>

        <!-- Números dos minutos (mais interno, só quando selecionando minutos) -->
        <g class="clock-numbers minutes-inner" *ngIf="!showingHours">
          <!-- Círculo ativo atrás do número selecionado -->
          <circle
            [attr.cx]="getMinutePosition(selectedMinute).x + 14"
            [attr.cy]="getMinutePosition(selectedMinute).y + 14"
            r="16"
            fill="#408AFA"
            class="active-circle minute-active"/>

          <text
            *ngFor="let minute of minutes"
            [attr.x]="getMinutePosition(minute).x + 14"
            [attr.y]="getMinutePosition(minute).y + 18"
            [class.active]="selectedMinute === minute"
            (click)="selectMinute(minute)"
            (keydown.enter)="selectMinute(minute)"
            (keydown.space)="selectMinute(minute)"
            tabindex="0"
            class="clock-number minute-number">
            {{ minute.toString().padStart(2, '0') }}
          </text>
        </g>

      </svg>

      <!-- AM/PM labels fixos -->
      <div class="period-labels">
        <button type="button" class="period-label am-label" [class.active]="isAM" (click)="isAM = true">AM</button>
        <button type="button" class="period-label pm-label" [class.active]="!isAM" (click)="isAM = false">PM</button>
      </div>
    </div>

    <!-- Botões de ação -->
    <div class="action-buttons">
      <button
        type="button"
        class="cancel-btn"
        (click)="onCancel()">
        Cancelar
      </button>
      <button
        type="button"
        class="apply-btn"
        (click)="onApply()">
        Aplicar
      </button>
    </div>

  </div>
</div>
